/**
 * Мост между mobx-стором платформенного токена и React.
 *
 * `mobx-react-lite` в проекте нет и ставить его ради одного гейта не за что:
 * `autorun` из уже установленного `mobx` подписывается ровно на те поля, которые
 * прочитаны внутри него, и снимает подписку возвращённым disposer'ом. Снимок
 * плоский и сравнивается по полям — иначе каждый прогон autorun'а давал бы новый
 * объект и лишний рендер даже без изменений.
 */

import { useEffect, useState } from 'react';
import { autorun } from 'mobx';
import type { PlatformTokenStatus } from '@aseller/platform-token';
import { platformTokenStore } from '../../shared/api/client';

export interface PlatformTokenSnapshot {
  status: PlatformTokenStatus;
  expiredPromptDismissed: boolean;
}

function readSnapshot(): PlatformTokenSnapshot {
  return {
    status: platformTokenStore.status,
    expiredPromptDismissed: platformTokenStore.expiredPromptDismissed,
  };
}

function sameSnapshot(a: PlatformTokenSnapshot, b: PlatformTokenSnapshot): boolean {
  return a.status === b.status && a.expiredPromptDismissed === b.expiredPromptDismissed;
}

export function usePlatformTokenSnapshot(): PlatformTokenSnapshot {
  const [snapshot, setSnapshot] = useState<PlatformTokenSnapshot>(readSnapshot);

  useEffect(
    () =>
      autorun(() => {
        // Чтение обоих полей ОБЯЗАНО происходить здесь, а не в апдейтере
        // setState: апдейтер выполняется позже, вне слежения mobx, и подписка
        // не завелась бы вовсе.
        const next = readSnapshot();
        setSnapshot((prev) => (sameSnapshot(prev, next) ? prev : next));
      }),
    [],
  );

  return snapshot;
}
